import React from 'react'

export default class IconsMainNavAddContact extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M1.33331 14C1.33326 12.9736 1.6294 11.9689 2.18621 11.1066C2.74302 10.2443 3.53683 9.56099 4.47238 9.13869C5.40793 8.71638 6.44547 8.57301 7.46049 8.7258C8.4755 8.87858 9.42487 9.32101 10.1946 10'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M6.66665 8.66667C8.5076 8.66667 9.99998 7.17428 9.99998 5.33333C9.99998 3.49238 8.5076 2 6.66665 2C4.8257 2 3.33331 3.49238 3.33331 5.33333C3.33331 7.17428 4.8257 8.66667 6.66665 8.66667Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12.6667 10.6667V14.6667'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.6667 12.6667H10.6667'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
